import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  APP_BING_BIDDING_API_ENDPOINT,
  APP_BING_PPA_BIDDING_API_ENDPOINT,
} from "constants/api_urls";

const BING_API_CONFIG = {
  bing: {
    endpoint: APP_BING_BIDDING_API_ENDPOINT,
    path: "bing-hotel-ads",
  },
  bingPropertyPromotionAds: {
    endpoint: APP_BING_PPA_BIDDING_API_ENDPOINT,
    path: "bing-ppa-hotel-ads",
  },
};

export const useBingBiddingApi = () => {
  const platformId = useSelector(
    (state) => state?.metaSearch?.platform?.[0]?.id
  );

  // Memoize so the returned references stay stable across renders. Without this,
  // consumers that depend on these values in a useEffect (e.g. the bidding-panel
  // fetch) would re-run on every render and trigger an infinite request loop.
  return useMemo(() => {
    const { endpoint, path } =
      BING_API_CONFIG[platformId] || BING_API_CONFIG.bing;

    return {
      biddingPanelInfoUrl: (accountId) =>
        `${endpoint}/api/${path}/bidding-panel-info/${accountId}/`,
      updateBidsUrl: `${endpoint}/api/${path}/update-bids/`,
    };
  }, [platformId]);
};
